export default $ => {
  let debounce = require('lodash/debounce')

  class UploadImage {
    constructor(div) {
      this.div = $(div);
      this.input = this.div.find('input').change(this.onUpload.bind(this)).val('');
      this.width = this.input.data('width');
      this.height = this.input.data('height');
      this.div_editor = this.div.find('.image-editor');
      this.image = this.div_editor.find('img').hide();
      this.image.on('crop',debounce(this.onCrop.bind(this),200));
      this.crop_info = this.div.find('.form_image_crop');
      this.uploadUrl = null;
      this.options = {
        aspectRatio: this.width / this.height,
        viewMode: 3
      }
    }
    onCrop() {
      this.crop_info.val(JSON.stringify(this.image.cropper('getData')));
    }

    onUpload(e) {
        let files = e.target.files;
        let file;

        if (files && files.length) {
          file = files[0];

          if (/^image\/\w+$/.test(file.type)) {

            if (this.uploadUrl) {
              URL.revokeObjectURL(this.uploadUrl);
            }

            this.uploadUrl = URL.createObjectURL(file);
            this.image.show();
            if (this.image.cropper)
              this.image.cropper('destroy');
            this.image.attr('src', this.uploadUrl);
            console.log(this.image);
            this.image.cropper(this.options);
          } else {
            window.alert('Invalid image');
          }
        }
    }

  }

  $('.eFormBuilderImageUpload').each(function ()
  {
      new UploadImage(this);
  })
}



// WEBPACK FOOTER //
// ./assets/js/scripts/upload-image.js